module.exports = __webpack_public_path__ + "static/media/luckyThree-3.f576f063.png";